import { render, staticRenderFns } from "./CustomOverlay.vue?vue&type=template&id=6079a42a&"
import script from "./CustomOverlay.vue?vue&type=script&lang=js&"
export * from "./CustomOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CustomOverlay.vue?vue&type=style&index=0&id=6079a42a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports